import React, { FC, useEffect, useState } from 'react';

import { IconEnum } from 'components/common/Icon';
import InputContainer from 'components/common/InputContainer';
import TextInput from 'components/common/Inputs/TextInput';

interface SaveCalculatorInputProps {
    currentName: string;
    hasExistingCalculation: boolean;
    onSave: (name: string) => void;
    onDuplicate?: () => void;
}

const SaveCalculatorInput: FC<SaveCalculatorInputProps> = ({
    currentName,
    onSave
}) => {
    const [name, setName] = useState(currentName);
    useEffect(() => {
        setName(currentName);
    }, [currentName]);

    const handleSave = () => {
        onSave(name);
    };

    return (
        <InputContainer
            title="Zapisz kalkulację"
            icon={IconEnum.BOOKMARK}
        >
            <TextInput
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Wpisz nazwę kalkulacji..."
                onAction={handleSave}
                actionIcon={IconEnum.ARROW_RIGHT}
                icon={IconEnum.BOOKMARK}
                outline
                variant="warning"
                isSaveFilterButton
            />
        </InputContainer>
    );
};

export default SaveCalculatorInput;
